import type { Starter } from '../Starter'

/**
 * Partner starter packs (starter-registry plan PR-J / P4) — shipped AS
 * CODE for the first partners (strategy-plan open-question decision).
 * Pack starters live in the same registry under the `partner` namespace,
 * gated by the PARTNER_PACKS org allowlist flag — the existing
 * requiredFlag filter hides them everywhere for unflagged orgs.
 *
 * Engagement integration (audit correction 2026-06-11): the scaffold
 * PINS `pinnedRefs` as ordinary org-level org_starters rows in the
 * client org (curation); folder CONTENT deployment stays with the
 * EngagementService scaffold + GRC seeder.
 */

export interface PartnerPack {
  id: string
  name: string
  description: string
  /** Registry ids (creately or pack starters) the scaffold pins. */
  pinnedRefs: string[]
  starters: Starter[]
}

export const PARTNER_PACKS: PartnerPack[] = [
  {
    id: 'iso27001-starter-pack',
    name: 'ISO 27001 Starter Pack',
    description:
      'Auditor-curated readiness shelf: ISMS scope, Annex A control checklist, risk register, vendor map.',
    pinnedRefs: [
      'iso27001-annex-a-checklist',
      'isms-scope-map',
      'risk-register',
      'vendor-risk-map',
    ],
    starters: [
      {
        id: 'iso27001-annex-a-checklist',
        name: 'ISO 27001 Annex A Checklist',
        description: 'Controls × readiness status',
        thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
        artifact: { kind: 'seed', seedId: 'iso27001-annex-a-checklist', diagramType: 'flowchart' },
        job: ['assess-risk'],
        function: ['risk-compliance'],
        growsInto: 'compass',
        trigger: 'audit-due',
        collaborative: ['assign-owners', 'external-review'],
        requiredFlag: 'PARTNER_PACKS',
        curatedBy: 'partner',
        packId: 'iso27001-starter-pack',
      },
      {
        id: 'isms-scope-map',
        name: 'ISMS Scope Map',
        description: 'Systems · sites · people in scope',
        thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
        artifact: { kind: 'seed', seedId: 'isms-scope-map', diagramType: 'flowchart' },
        job: ['assess-risk'],
        function: ['risk-compliance'],
        growsInto: 'compass',
        collaborative: ['external-review'],
        requiredFlag: 'PARTNER_PACKS',
        curatedBy: 'partner',
        packId: 'iso27001-starter-pack',
      },
    ],
  },
]

export function getPartnerPack(packId: string): PartnerPack | null {
  return PARTNER_PACKS.find((p) => p.id === packId) ?? null
}
